import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators, FormGroup, AbstractControl } from '@angular/forms';
import { APILoginService } from '../../_services/login/API-login';
import { APIEntityService } from '../../_services/entity/API-entity';
import { $ModalManagerService } from '../../../../_helpers/Modals/ModalManager.service';
import { formatDate } from '@angular/common';
import { Constants } from '../../../../_utils/Constants';
import { $DBManagerService } from '../../../../_helpers/DB/DBManager.service';
import { Router, ActivatedRoute } from '@angular/router';



export interface Id {
  value: string;
  viewValue: string;
}

const now = new Date()
const time_today = now.getTime()
const formatTime = formatDate(time_today, 'HH:mm', 'en-US', '+0530')
const currentdat = formatDate(now, 'dd-MM-yyyy', 'en-US', '+0530')

@Component({
  selector: 'app-modify-registrar',
  templateUrl: './modify-registrar.component.html',
  styleUrls: ['./modify-registrar.component.css']
})
export class ModifyRegistrarComponent implements OnInit {

  entityForm: FormGroup;
  registrarRole: any;
  Ttsl_ID: any
  response: any;
  Approver_ID: any;
  public SelectRegistrarRole:any=[];

  selectedRole:any=[];

  constructor(private fb: FormBuilder,
    private ls: APILoginService,
    private es: APIEntityService,
    private $modal: $ModalManagerService,
    private db: $DBManagerService,
    private _route: ActivatedRoute,
    private router: Router) {
    this._route.params.subscribe((params) => {
      this.registrarRole = params['registrarRole'];
      this.Ttsl_ID = params['Ttsl_ID']; 
    })
    this.setValues();

  }
  RegistrarRole = [
    { value: '4', viewValue: 'Finance Admin' },
    { value: '100', viewValue: 'Network Admin' },
    { value: '201', viewValue: 'Preference Process Owner' },
    { value: '202', viewValue: 'Entity Process Owner' },
    { value: '203', viewValue: 'Header Process Owner' },
    { value: '204', viewValue: 'Content Template Process Owner' },
    { value: '205', viewValue: 'Consent Template Process Owner' },
    { value: '206', viewValue: 'Complaints Process Owner' },
    { value: '207', viewValue: 'Scrubbing SMS Process Owner' }, 
     { value: '208', viewValue: 'Scrubbing Voice Process Owner' },
    { value: '209', viewValue: 'Delivery SMS Process Owner' },
    { value: '210', viewValue: 'Delivery voice Process Owner' },
     { value: '302', viewValue: 'Entity Registrar' },
    { value: '303', viewValue: 'Header Registrar' },
    { value: '304', viewValue: 'Content Template Registrar' },
    { value: '305', viewValue: 'Consent Template Registrar' }, 
    { value: '306', viewValue: 'Complaints Registrar' },
   { value: '307', viewValue: 'Scrubbing SMS Registrar' },
   { value: '308', viewValue: 'Scrubbing Voice Registrar' },   
    { value: '309', viewValue: 'Delivery SMS Registrar' },
   { value: '310', viewValue: 'Delivery Voice Registrar' },
   { value: '311', viewValue: 'Complaints Supervisor' },
   { value: '501', viewValue: 'TTL Agent' },
   { value: '601', viewValue: 'Preference Manager' }

  ];

  ngOnInit() {

    this.entityForm = this.fb.group({
      Ttsl_ID: ['',],
      Ttsl_UserName: [''],
      Ttsl_EmailID: [''],
      Ttsl_MobileNo: [''],
      Ttsl_Designation: [''],
      Ttsl_Department: [''],
      Status: [''],
      RegistrarRolefield:['']

    });
    this.Approver_ID = this.db.get(Constants.SESSSION_STORAGE, Constants.ENTITY_ID)


  }
  role;
  checkrole:any={};
  checkstatus:any={};
  setValues() {
	
	if(!this.Ttsl_ID)
		this.Ttsl_ID = this.db.get(Constants.SESSSION_STORAGE, Constants.TTSL_ID)  
	
	console.log("setValues this.Ttsl_ID", this.Ttsl_ID)  
	
    this.es.getGeTTLUserDetails(this.Ttsl_ID) 
      .subscribe(r => {

        this.response = r[0]
        console.log("response ", r)


        this.entityForm.controls['Ttsl_ID'].setValue( this.response.Ttsl_ID);
        this.entityForm.controls['Ttsl_UserName'].setValue( this.response.Ttsl_UserName);
        this.entityForm.controls['Ttsl_MobileNo'].setValue( this.response.Ttsl_MobileNo);
        this.entityForm.controls['Ttsl_Department'].setValue( this.response.Ttsl_Department);
        this.entityForm.controls['Ttsl_Designation'].setValue( this.response.Ttsl_Designation);
        this.entityForm.controls['Ttsl_EmailID'].setValue( this.response.Ttsl_EmailID);
     //   this.entityForm.controls['Status'].setValue( this.response.Ttsl_Status);
        this.entityForm.controls['Status'].setValue(this.response.Registrar_Status[Object.keys(this.response.Registrar_Status)[0]]); 

        this.checkrole=this.response.Registrar_Status;
        this.checkstatus=this.response.Registrar_Status;
         this.role=this.response.Ttsl_RegistrarRole;
        //  this.selectedRole=Object.keys(this.response.Registrar_Status)
        let roleStatus=this.response.Registrar_Status||{};
        for (var key in roleStatus) {
          if(this.checkrole[key] === 'A'||this.checkrole[key] === 'I'){
            this.selectedRole.push(key)
          }
        }
        console.log("my roles", this.selectedRole);
         this.entityForm.controls['RegistrarRolefield'].setValue(this.selectedRole[0]);
              for(var i=0;i<=this.RegistrarRole.length-1;i++){
                for(var j=0;j<=this.selectedRole.length-1;j++){
                  if(this.RegistrarRole[i].value == this.selectedRole[j]){
                    this.SelectRegistrarRole.push(this.RegistrarRole[i]);
                  }
                }
              }

        // console.log("this.registrarRole", this.registrarRole)
        // console.log("Status", r['Registrar_Status'][this.registrarRole])

        // this.entityForm.controls['Status'].setValue(r['Registrar_Status'][this.registrarRole]);

      })

  }
  onRoleChange(role){
    for (var key in this.checkstatus) {
      if(key === role){
        this.entityForm.controls['Status'].setValue(this.checkstatus[key]);
      }
    }

  }
  onSubmit() {
    let sts = this.entityForm.get("Status").value
    let role = this.entityForm.get("RegistrarRolefield").value
       let selStatus=sts === 'A'? 'A':'I';
    //  let obj={}
         this.selectedRole;

         for (var key in this.checkrole) {
           if(key === role){
            this.checkrole[key]=selStatus;
           }
         }

	console.log(this.checkrole);
    var data = {
      "Ttsl_ID":  this.Ttsl_ID,
      "Ttsl_RegistrarRole": this.role,
      "Registrar_Status":this.checkrole,
      "Approver_ID":this.db.get(Constants.SESSSION_STORAGE, Constants.TTSL_ID),
      "sts":sts,
      "role":role,
      "Ttsl_Ref_No":this.response.Ttsl_Ref_No  
    }
    

    this.es.modifyStatus(data)
      .subscribe(r => {



        if (r.status == "success") {
          // if (sts == "I") {
            this.$modal.successModal({
              title: 'Success',
              msg: r.message
            })
					this.router.navigateByUrl('/ttlusers-summary')
        } 
          // else{
          //   this.$modal.successModal({
          //     title: 'Success',
          //     msg: 'Ttsl User has been set Active '
          //   })

          // }
       // }
        else if(r.status == "fail") {
          this.$modal.errorModal({
            title: 'Error',
            msg: r.message
          })
        }
        
      })

  }
}

